const delItem = (array, id) => {
  const delItem = array.find(item => item.id === id)
  const ind = array.indexOf(delItem)
  array.splice(ind, 1)
  return array
}
export default delItem